module.exports = __webpack_public_path__ + "img/Flag_of_Liechtenstein.a93436b8.svg";